// 日本語ハイライト用の簡易辞書
export const ANSWER_HINTS = {
  a: {
    matches: ['一', '１', 'ひと', 'ある'],
    description: '不特定の1つを示す冠詞。「一つの〜／ある〜」というニュアンス。',
  },
  about: {
    matches: ['約', 'およそ', 'について'],
    description: 'about = 「約〜」「〜について」。対象に関する話題を示します。',
  },
  after: {
    matches: ['後', 'あと', 'してから', 'たら'],
    description: 'after = 「〜の後で」「〜してから」。時間的な順序を表現。',
  },
  agree: {
    matches: ['同意', '賛成'],
    description: 'agree = 「同意する／賛成する」。気持ちや意見が一致すること。',
  },
  all: {
    matches: ['全て', 'すべて', '全部', '一日中', 'みんな'],
    description: 'all = 「全部」「すべて」「一日中」など全体を表す語。',
  },
  am: {
    matches: ['です', 'だ', 'いる', '私は'],
    description: 'am = be動詞の一人称。「〜です／〜である」という状態を作ります。',
  },
  another: {
    matches: ['もう一', '別', '他'],
    description: 'another = 「もう一つの」「別の」。追加・代替を表す語。',
  },
  are: {
    matches: ['です', 'だ', 'いる', 'あります'],
    description: 'are = be動詞の複数形。「〜です」「〜がある／いる」。',
  },
  as: {
    matches: ['同じ', 'ように', 'として', 'ほど'],
    description: 'as = 「〜のように」「〜として」など比較や役割を示します。',
  },
  asked: {
    matches: ['頼', '求め', '聞', '尋ね'],
    description: 'asked = 「頼んだ」「尋ねた」。 ask の過去形。',
  },
  at: {
    matches: ['で', 'に', '時', '場所'],
    description: 'at = 「〜で」「〜に」。地点や時刻を示す前置詞。',
  },
  away: {
    matches: ['離れ', '去', '遠く', 'どこか'],
    description: 'away = 「離れて」「去って」。距離をおくイメージ。',
  },
  bath: {
    matches: ['風呂', '入浴'],
    description: 'bath = 「お風呂」「入浴」。',
  },
  became: {
    matches: ['なった', 'になった'],
    description: 'became = become の過去形。「〜になった」。',
  },
  because: {
    matches: ['なぜなら', 'から', 'ため'],
    description: 'because = 「〜だから」「〜なので」。理由を示します。',
  },
  before: {
    matches: ['前', 'まえ', 'より前'],
    description: 'before = 「〜の前に」。時間や順序を示す語。',
  },
  belongs: {
    matches: ['属', '所属', 'もの'],
    description: 'belongs = 「〜に属している」「〜のものだ」。',
  },
  born: {
    matches: ['生ま', '誕'],
    description: 'born = 「生まれた」。 be born の形で使います。',
  },
  broke: {
    matches: ['壊', '破', '割', '折'],
    description: 'broke = break の過去形。「壊した／壊れた」。',
  },
  business: {
    matches: ['仕事', 'ビジネス', '用事'],
    description: 'business = 「仕事」「商売」「用事」。',
  },
  but: {
    matches: ['しかし', 'でも', 'けれど'],
    description: 'but = 逆接。「しかし〜」「でも〜」。',
  },
  buy: {
    matches: ['買'],
    description: 'buy = 「買う」。',
  },
  by: {
    matches: ['で', 'によって', 'そば', 'まで'],
    description: 'by = 「〜で」「〜によって」「〜までに」。前置詞の定番。',
  },
  came: {
    matches: ['来', 'やって来'],
    description: 'came = come の過去形。「来た」。',
  },
  caught: {
    matches: ['捕', 'つかま', 'かか'],
    description: 'caught = 「捕まえた」「〜にかかった」。catch の過去形。',
  },
  cold: {
    matches: ['風邪', '寒', '冷'],
    description: 'cold = 「風邪」「寒さ」。',
  },
  covered: {
    matches: ['覆', 'おおわ', 'かぶさ'],
    description: 'covered = 「覆われた」。 cover の過去分詞。',
  },
  crowded: {
    matches: ['混雑', 'いっぱい'],
    description: 'crowded = 「混んでいる」「いっぱいの」。',
  },
  cup: {
    matches: ['カップ', '杯'],
    description: 'cup = 「カップ」「〜杯」。数量を表す名詞。',
  },
  day: {
    matches: ['日', '日中', '一日'],
    description: 'day = 「日」「一日」。',
  },
  died: {
    matches: ['死', '亡'],
    description: 'died = die の過去形。「亡くなった」。',
  },
  eat: {
    matches: ['食べ'],
    description: 'eat = 「食べる」。',
  },
  end: {
    matches: ['終', '最後', '末'],
    description: 'end = 「終わり」「末」。',
  },
  enjoying: {
    matches: ['楽し', '満喫'],
    description: 'enjoying = 「楽しんでいる」進行形。',
  },
  fact: {
    matches: ['実は', '事実'],
    description: 'fact = 「事実」「本当のところ」。',
  },
  felt: {
    matches: ['感じ'],
    description: 'felt = feel の過去形。「感じた」。',
  },
  filled: {
    matches: ['満', 'いっぱい', '満ち'],
    description: 'filled = 「満たされた」。fill の過去分詞。',
  },
  first: {
    matches: ['まず', '最初', '第一'],
    description: 'first = 「最初」「第一」。',
  },
  for: {
    matches: ['ため', 'にとって', '期間', 'へ'],
    description: 'for = 「〜のため」「〜に対して」「〜の間」。',
  },
  found: {
    matches: ['見つけ', '発見'],
    description: 'found = 「見つけた」。find の過去形。',
  },
  friend: {
    matches: ['友達', '友だち'],
    description: 'friend = 「友達」。',
  },
  friends: {
    matches: ['友人', '友だち', '仲間'],
    description: 'friends = 「友人たち」「仲間」。',
  },
  from: {
    matches: ['から', '出身'],
    description: 'from = 「〜から」。起点を示します。',
  },
  full: {
    matches: ['いっぱい', '満員', '満た'],
    description: 'full = 「いっぱいの」「満たされた」。',
  },
  give: {
    matches: ['あげ', '与え', '渡'],
    description: 'give = 「与える」「渡す」。',
  },
  glass: {
    matches: ['グラス', '杯', 'コップ'],
    description: 'glass = 「グラス」「コップ一杯」。',
  },
  go: {
    matches: ['行'],
    description: 'go = 「行く」。',
  },
  got: {
    matches: ['得', 'なった', '着', '手に入', 'わか'],
    description: 'got = 「得た」「〜になった」「着いた」。get の過去形。',
  },
  grows: {
    matches: ['育', '成長'],
    description: 'grows = 「成長する」「育つ」。',
  },
  had: {
    matches: ['持', 'あった', '経験', '食べた'],
    description: 'had = 「持っていた」「〜した」。have の過去形。',
  },
  heard: {
    matches: ['聞', '耳'],
    description: 'heard = 「聞いた」。hear の過去形。',
  },
  hello: {
    matches: ['よろしく', 'こんにちは', 'どうぞ'],
    description: 'hello = あいさつ。「こんにちは」「よろしく」。',
  },
  help: {
    matches: ['手伝', '助'],
    description: 'help = 「手伝う」「助ける」。',
  },
  here: {
    matches: ['ここ', 'こちら'],
    description: 'here = 「ここ」「こちら」。',
  },
  herself: {
    matches: ['自分', '自身', '彼女'],
    description: 'herself = 「彼女自身」「自分で」。',
  },
  his: {
    matches: ['彼', '彼の'],
    description: 'his = 「彼の」。所有を示します。',
  },
  home: {
    matches: ['家', 'うち'],
    description: 'home = 「家」「自宅」。',
  },
  how: {
    matches: ['どう', 'どれほど', 'どのよう'],
    description: 'how = 「どう」「どのように」。方法や程度を尋ねる語。',
  },
  hurry: {
    matches: ['急', '急い'],
    description: 'hurry = 「急ぐ」。',
  },
  impressed: {
    matches: ['感銘', '感動', '感心'],
    description: 'impressed = 「感銘を受けた」。impress の過去分詞。',
  },
  in: {
    matches: ['中', 'で', 'に'],
    description: 'in = 「〜の中で」「〜に」。場所や状態を表現。',
  },
  instead: {
    matches: ['代わり'],
    description: 'instead = 「代わりに」。',
  },
  is: {
    matches: ['です', 'だ', 'である', 'いる'],
    description: 'is = be動詞。「〜です」「〜である」。',
  },
  "isn't": {
    matches: ['ではなく', 'じゃない', 'ではありません'],
    description: "isn't = 「〜ではない」。be動詞の否定形。",
  },
  "it's": {
    matches: ['それは', '〜だよ', '〜です'],
    description: "it's = 「それは〜だ」。it is の短縮。",
  },
  just: {
    matches: ['ちょうど', 'たった今', 'まさに'],
    description: 'just = 「ちょうど」「たった今」。強調や直前を示す語。',
  },
  killed: {
    matches: ['殺', '亡'],
    description: 'killed = 「殺された」。kill の過去分詞。',
  },
  kind: {
    matches: ['種類', '種', '親切'],
    description: 'kind = 「種類」「一種」。文脈によっては「親切な」。',
  },
  late: {
    matches: ['遅', '遅く'],
    description: 'late = 「遅い」「遅く」。',
  },
  laughed: {
    matches: ['笑'],
    description: 'laughed = laugh の過去形。「笑った」。',
  },
  least: {
    matches: ['少なくとも'],
    description: 'least = 「少なくとも」。',
  },
  lie: {
    matches: ['うそ', '嘘'],
    description: 'lie = 「うそ」「嘘をつく」。',
  },
  long: {
    matches: ['長', '長い間'],
    description: 'long = 「長い」「長く」。',
  },
  looked: {
    matches: ['見', '眺'],
    description: 'looked = 「見た」「見えた」。look の過去形。',
  },
  lost: {
    matches: ['失', '迷'],
    description: 'lost = 「失った」「迷った」。lose の過去形。',
  },
  made: {
    matches: ['作', '作っ', 'させ'],
    description: 'made = make の過去形。「作った」「〜させた」。',
  },
  make: {
    matches: ['作', '〜にする', '生み'],
    description: 'make = 「作る」「〜にする」。',
  },
  many: {
    matches: ['多く', 'たくさん'],
    description: 'many = 「たくさんの」。',
  },
  member: {
    matches: ['一員', 'メンバー'],
    description: 'member = 「メンバー」「一員」。',
  },
  mind: {
    matches: ['決心', '心'],
    description: 'mind = 「心」「決意」。make up one’s mind などで使用。',
  },
  mine: {
    matches: ['私のもの', '私の友達', '私の'],
    description: 'mine = 「私のもの」。所有を表す代名詞。',
  },
  mistake: {
    matches: ['間違'],
    description: 'mistake = 「間違い」。',
  },
  my: {
    matches: ['私の'],
    description: 'my = 「私の」。所有を示す。',
  },
  now: {
    matches: ['今', '現在'],
    description: 'now = 「今」「現在」。',
  },
  of: {
    matches: ['の'],
    description: 'of = 「〜の」「〜から」。所属や部分を示します。',
  },
  off: {
    matches: ['降', '切', '外', '消'],
    description: 'off = 「離れて」「切って」「オフに」。',
  },
  on: {
    matches: ['上', 'に', 'で'],
    description: 'on = 「〜の上に」「〜で」。',
  },
  one: {
    matches: ['一', '１', 'ひと'],
    description: 'one = 「一つ」「一人」。',
  },
  order: {
    matches: ['注文', '順番', '命令'],
    description: 'order = 「注文」「順序」「命令」。',
  },
  out: {
    matches: ['外', '出', '消'],
    description: 'out = 「外に」「出て」「消えて」。',
  },
  over: {
    matches: ['終わ', '越え', '以上'],
    description: 'over = 「終わって」「〜を越えて」「以上」。',
  },
  paid: {
    matches: ['払'],
    description: 'paid = pay の過去形。「支払った」。',
  },
  pair: {
    matches: ['一足', '一組', 'ペア'],
    description: 'pair = 「一組」「一足」。',
  },
  part: {
    matches: ['一部', '参加', 'パート'],
    description: 'part = 「一部分」「参加する」。',
  },
  pick: {
    matches: ['拾', '選', '迎え'],
    description: 'pick = 「拾う」「選ぶ」「迎えに行く」。',
  },
  piece: {
    matches: ['一片', 'ひと切れ', 'ピース'],
    description: 'piece = 「一片」「ひとかけら」。',
  },
  pleased: {
    matches: ['気に入', '喜'],
    description: 'pleased = 「満足している」「気に入っている」。',
  },
  proud: {
    matches: ['誇'],
    description: 'proud = 「誇りに思う」。',
  },
  put: {
    matches: ['置', '入', '着'],
    description: 'put = 「置く」「入れる」「着る」。',
  },
  ran: {
    matches: ['走', '逃げ'],
    description: 'ran = run の過去形。「走った」。',
  },
  reading: {
    matches: ['読'],
    description: 'reading = 「読んでいる」。read の進行形。',
  },
  ready: {
    matches: ['準備', '用意'],
    description: 'ready = 「準備ができた」。',
  },
  rest: {
    matches: ['休', 'ひと休み'],
    description: 'rest = 「休む」「休み」。',
  },
  right: {
    matches: ['右', '正し', 'ちょうど'],
    description: 'right = 「右」「正しい」「ちょうど」。',
  },
  run: {
    matches: ['走', '運営'],
    description: 'run = 「走る」「運営する」。',
  },
  same: {
    matches: ['同じ'],
    description: 'same = 「同じ」。',
  },
  say: {
    matches: ['言'],
    description: 'say = 「言う」。',
  },
  see: {
    matches: ['見'],
    description: 'see = 「見る」「会う」。',
  },
  sits: {
    matches: ['座'],
    description: 'sits = 「座る」。sit の三人称単数。',
  },
  smile: {
    matches: ['笑', '微笑'],
    description: 'smile = 「ほほ笑む」。',
  },
  soon: {
    matches: ['すぐ', 'まもなく'],
    description: 'soon = 「まもなく」「すぐに」。',
  },
  sorry: {
    matches: ['すま', 'ごめ', '気の毒'],
    description: 'sorry = 「申し訳ない」「気の毒に思う」。',
  },
  stands: {
    matches: ['立'],
    description: 'stands = 「立つ」。stand の三人称単数。',
  },
  start: {
    matches: ['始め'],
    description: 'start = 「始める」「始まる」。',
  },
  stays: {
    matches: ['滞在', '泊', '居'],
    description: 'stays = 「滞在する」「泊まる」。',
  },
  study: {
    matches: ['勉強'],
    description: 'study = 「勉強する」。',
  },
  such: {
    matches: ['そんな', 'そのよう'],
    description: 'such = 「そのような」「そんな」。',
  },
  suffers: {
    matches: ['苦し'],
    description: 'suffers = 「苦しむ」。suffer の三人称単数。',
  },
  surprised: {
    matches: ['驚'],
    description: 'surprised = 「驚いた」。surprise の過去分詞。',
  },
  swimming: {
    matches: ['泳'],
    description: 'swimming = 「泳ぐこと」「泳いでいる」。',
  },
  take: {
    matches: ['取', '連', 'かか', '受け'],
    description: 'take = 「取る」「連れていく」「（時間が）かかる」。',
  },
  takes: {
    matches: ['取', '連', 'かか'],
    description: 'takes = 「取る」「連れていく」「〜かかる」。',
  },
  taking: {
    matches: ['取', '連', 'かか'],
    description: 'taking = 「取っている」「連れていくところ」「所要」。',
  },
  tell: {
    matches: ['伝', '言'],
    description: 'tell = 「伝える」「言う」。',
  },
  than: {
    matches: ['より'],
    description: 'than = 「〜より」。比較級を作る語。',
  },
  the: {
    matches: ['その', '例の'],
    description: 'the = 定冠詞。「その」「例の」。',
  },
  themselves: {
    matches: ['自分たち', '彼ら自身'],
    description: 'themselves = 「彼ら自身」「自分たちで」。',
  },
  this: {
    matches: ['この'],
    description: 'this = 「この」「こちらの」。',
  },
  time: {
    matches: ['時', '時間'],
    description: 'time = 「時間」「時」。',
  },
  times: {
    matches: ['回', '度'],
    description: 'times = 「〜回」「〜度」。',
  },
  tired: {
    matches: ['疲', '飽'],
    description: 'tired = 「疲れた」「飽きた」。',
  },
  to: {
    matches: ['へ', 'に', 'ため', 'ように'],
    description: 'to = 「〜へ」「〜に」「〜するために」。',
  },
  too: {
    matches: ['も', 'あまりに'],
    description: 'too = 「〜も」「あまりに〜すぎる」。',
  },
  took: {
    matches: ['取', '連', 'かか'],
    description: 'took = take の過去形。「取った」「連れていった」。',
  },
  trip: {
    matches: ['旅', '旅行'],
    description: 'trip = 「旅行」「旅」。',
  },
  trouble: {
    matches: ['困', 'トラブル'],
    description: 'trouble = 「困難」「面倒」「トラブル」。',
  },
  try: {
    matches: ['試'],
    description: 'try = 「試す」「やってみる」。',
  },
  turn: {
    matches: ['向', '曲', '点', '回'],
    description: 'turn = 「向きを変える」「点ける／消す」。',
  },
  turned: {
    matches: ['点', '向', '曲', '変わ'],
    description: 'turned = turn の過去形。「向きを変えた」「点けた／消した」。',
  },
  up: {
    matches: ['上', '起', '立'],
    description: 'up = 「上へ」「起き上がる」。',
  },
  usual: {
    matches: ['いつも', '普段'],
    description: 'usual = 「いつもの」「ふだんの」。',
  },
  walk: {
    matches: ['歩'],
    description: 'walk = 「歩く」。',
  },
  was: {
    matches: ['だった', 'でした', 'いた'],
    description: 'was = be動詞の過去形。「〜だった／〜でした」。',
  },
  way: {
    matches: ['方法', '道', 'やり方'],
    description: 'way = 「道」「方法」「やり方」。',
  },
  went: {
    matches: ['行', '出かけ'],
    description: 'went = go の過去形。「行った」。',
  },
  were: {
    matches: ['だった', 'いた'],
    description: 'were = be動詞の複数過去。「〜だった／〜いた」。',
  },
  while: {
    matches: ['間', 'あいだ'],
    description: 'while = 「〜の間」。',
  },
  with: {
    matches: ['と', 'と一緒に', 'で'],
    description: 'with = 「〜と一緒に」「〜を使って」。',
  },
  worked: {
    matches: ['働', '勤め'],
    description: 'worked = work の過去形。「働いた」「勤めた」。',
  },
  you: {
    matches: ['あなた', '君'],
    description: 'you = 「あなた」「君」。',
  },
  your: {
    matches: ['あなたの'],
    description: 'your = 「あなたの」。所有を示す。',
  },
  yourself: {
    matches: ['自分', 'あなた自身'],
    description: 'yourself = 「あなた自身」「自分で」。',
  },
  able: {
    matches: ['できる'],
    description: 'be able to ~ = 「(現実に)〜できる」。',
  },
  absent: {
    matches: ['欠席'],
    description: 'be absent from ~ = 「〜を欠席する」。',
  },
  afraid: {
    matches: ['恐れる', '怖が', 'ではないか'],
    description: 'be afraid of ~ = 「〜を恐れる」。I\'m afraid (that) ~ = 「〜ではないかと思う」。',
  },
  age: {
    matches: ['歳', '年齢'],
    description: 'at the age of ~ = 「〜歳の時に」。',
  },
  also: {
    matches: ['も'],
    description: 'not only A but (also) B = 「AだけでなくBも」。',
  },
  and: {
    matches: ['と'],
    description: 'between A and B / both A and B = 「AとBの間に／AもBも」。',
  },
  any: {
    matches: ['もう'],
    description: 'not ~ any more = 「もう〜ない」。',
  },
  arrived: {
    matches: ['着いた'],
    description: 'arrived at[in] ~ = arrive の過去形。「〜に着いた」。',
  },
  be: {
    matches: ['である', 'なる'],
    description: 'be able to / be kind to など、be動詞の原形。助動詞の後や命令文で使う。',
  },
  bed: {
    matches: ['寝', 'ベッド'],
    description: 'go to bed = 「寝る」。be sick in bed = 「病気で寝ている」。',
  },
  been: {
    matches: ['ずっと'],
    description: 'been = be の過去分詞。has/have been で「ずっと〜の状態」を表す。',
  },
  best: {
    matches: ['最善'],
    description: 'do one\'s best = 「最善を尽くす」。',
  },
  better: {
    matches: ['方が好き', 'しないとだめ'],
    description: 'like A better than B = 「BよりAの方が好き」。had better ~ = 「〜しないとだめだ」。',
  },
  between: {
    matches: ['間に'],
    description: 'between A and B = 「AとBの間に」。',
  },
  borrowed: {
    matches: ['借りた'],
    description: 'borrowed = borrow の過去形。borrow A from B = 「BからAを借りる」。',
  },
  both: {
    matches: ['両方とも', 'も'],
    description: 'both A and B = 「AもBも両方とも」。',
  },
  brought: {
    matches: ['持って来た'],
    description: 'brought = bring の過去形。bring A to B = 「AをBに持って来る」。',
  },
  buying: {
    matches: ['買った'],
    description: 'forget -ing = 「〜したのを忘れる」。buying はすでにした行為。',
  },
  "can't": {
    matches: ['できない'],
    description: 'can\'t ~ any more = 「もう〜できない」。',
  },
  care: {
    matches: ['世話'],
    description: 'take care of ~ = 「〜の世話をする」。',
  },
  course: {
    matches: ['もちろん'],
    description: 'of course = 「もちろん」。',
  },
  days: {
    matches: ['頃', '最近'],
    description: 'in those days = 「当時、あの頃」。these days = 「最近」。',
  },
  did: {
    matches: ['した'],
    description: 'did = do の過去形。do one\'s best = 「最善を尽くす」。',
  },
  "didn't": {
    matches: ['なかった'],
    description: 'didn\'t ~ at all = 「全く〜しなかった」。',
  },
  different: {
    matches: ['異なる', '違う'],
    description: 'be different from ~ = 「〜と異なる、違う」。',
  },
  "don't": {
    matches: ['しなくてもよい', 'してはどうですか'],
    description: 'don\'t have to ~ = 「〜しなくてもよい」。Why don\'t you ~? = 「〜してはどうですか」。',
  },
  drive: {
    matches: ['運転'],
    description: 'drive = 「運転する」。be old enough to do ~ の do 部分。',
  },
  each: {
    matches: ['お互い'],
    description: 'each other = 「お互い」。',
  },
  either: {
    matches: ['どちらか'],
    description: 'either A or B = 「AかBかどちらか」。',
  },
  enough: {
    matches: ['できる年齢', '親切にも'],
    description: 'be ~ enough to do = 「…できるくらい〜」「親切にも〜する」。',
  },
  example: {
    matches: ['例えば'],
    description: 'for example = 「例えば」。',
  },
  famous: {
    matches: ['有名'],
    description: 'be famous for ~ = 「〜で有名である」。',
  },
  fond: {
    matches: ['好きだ'],
    description: 'be fond of ~ = 「〜が好きだ」。',
  },
  foot: {
    matches: ['徒歩'],
    description: 'on foot = 「徒歩で、歩いて」。',
  },
  forgot: {
    matches: ['忘れ'],
    description: 'forgot = forget の過去形。forget to do / forget -ing = 「〜するのを忘れる／したのを忘れる」。',
  },
  forward: {
    matches: ['楽しみ'],
    description: 'look forward to -ing = 「〜するのを楽しみにする」。',
  },
  front: {
    matches: ['前に', '正面'],
    description: 'in front of ~ = 「〜の前に、正面に」。',
  },
  future: {
    matches: ['将来'],
    description: 'in the future = 「将来(は)」。',
  },
  get: {
    matches: ['起きる'],
    description: 'get up = 「起きる」。',
  },
  gets: {
    matches: ['降りる'],
    description: 'get off ~ = 「〜を降りる」。',
  },
  good: {
    matches: ['上手', '得意'],
    description: 'be good at ~ = 「〜が上手だ、得意だ」。',
  },
  have: {
    matches: ['しなければならない'],
    description: 'have to ~ = 「〜しなければならない」。',
  },
  hear: {
    matches: ['だそうだ'],
    description: 'I hear (that) ~. = 「〜だそうだ」。人から聞いた話を伝える表現。',
  },
  helped: {
    matches: ['手伝った'],
    description: 'helped = help の過去形。help A with B = 「A(人)のB(物事)を手伝う」。',
  },
  her: {
    matches: ['彼女の'],
    description: 'on one\'s way to ~ の one\'s 部分。「彼女の」。',
  },
  hope: {
    matches: ['いいと思う'],
    description: 'I hope (that) ~. = 「〜ならいいと思う」。',
  },
  i: {
    matches: ['私'],
    description: 'I hear/hope (that) ~. の主語。「私は」。',
  },
  "i'm": {
    matches: ['私は'],
    description: 'I\'m afraid/sure (that) ~. の I am の短縮形。',
  },
  interested: {
    matches: ['興味'],
    description: 'be interested in ~ = 「〜に興味がある」。',
  },
  into: {
    matches: ['加工'],
    description: 'be made into ~ = 「〜に作られる、加工される」。',
  },
  introduced: {
    matches: ['紹介した'],
    description: 'introduced = introduce の過去形。introduce A to B = 「AをBに紹介する」。',
  },
  invited: {
    matches: ['招待した'],
    description: 'invited = invite の過去形。invite A to B = 「AをBに招待する」。',
  },
  known: {
    matches: ['知られている'],
    description: 'be known to ~ = 「〜に知られている」。',
  },
  last: {
    matches: ['遂に', 'とうとう'],
    description: 'at last = 「遂に、とうとう」。',
  },
  left: {
    matches: ['出発した'],
    description: 'left = leave の過去形。leave for ~ = 「〜へ向かう、出発する」。',
  },
  like: {
    matches: ['方が好き', '聞く'],
    description: 'like A better than B = 「BよりAの方が好きだ」。listen to = 「〜を聞く」。',
  },
  listen: {
    matches: ['聞く'],
    description: 'listen to ~ = 「〜を聞く」。',
  },
  lives: {
    matches: ['住んでいる'],
    description: 'live in ~ = 「〜に住む」。',
  },
  look: {
    matches: ['見る'],
    description: 'look at ~ = 「〜を見る」。',
  },
  looking: {
    matches: ['探して', '楽しみに'],
    description: 'look for ~ = 「〜を探す」。look forward to -ing = 「〜するのを楽しみにする」。',
  },
  more: {
    matches: ['もっと', '以上', 'もう'],
    description: 'more about ~ = 「〜についてもっと」。more than ~ = 「〜以上」。',
  },
  myself: {
    matches: ['自分自身', '心の中で'],
    description: 'say to oneself = 「心の中で考える」。myself は主語が I の時の oneself。',
  },
  next: {
    matches: ['隣'],
    description: 'next to ~ = 「〜の隣に」。',
  },
  not: {
    matches: ['ない', 'だけでなく'],
    description: 'not only A but (also) B = 「AだけでなくBも」。',
  },
  old: {
    matches: ['年齢'],
    description: 'be old enough to do ~ = 「〜できる年齢である」。',
  },
  once: {
    matches: ['すぐに', '直ちに'],
    description: 'at once = 「すぐに、直ちに」。',
  },
  only: {
    matches: ['だけ'],
    description: 'not only A but (also) B = 「AだけでなくBも」。',
  },
  or: {
    matches: ['か'],
    description: 'either A or B = 「AかBかどちらか」。',
  },
  other: {
    matches: ['他', '先日'],
    description: 'each other = 「お互い」。the other day = 「先日」。',
  },
  possible: {
    matches: ['できるだけ'],
    description: 'as ~ as possible = 「できるだけ〜」。',
  },
  said: {
    matches: ['考えた', '言った'],
    description: 'said = say の過去形。say to oneself = 「心の中で考える」。',
  },
  seeing: {
    matches: ['会える'],
    description: 'look forward to -ing の -ing 部分。「会えるのを」。',
  },
  share: {
    matches: ['共有'],
    description: 'share A with B = 「AをBと共有する」。',
  },
  shopping: {
    matches: ['買い物'],
    description: 'go shopping = 「買い物に行く」。',
  },
  sick: {
    matches: ['病気'],
    description: 'be sick in bed = 「病気で寝ている」。',
  },
  so: {
    matches: ['とても'],
    description: 'so ~ that .. = 「とても〜なので…」。',
  },
  some: {
    matches: ['いつか'],
    description: 'some day = 「(未来の)いつか」。',
  },
  stayed: {
    matches: ['泊まった'],
    description: 'stayed = stay の過去形。stay with ~ = 「〜のところに泊まる」。',
  },
  sure: {
    matches: ['きっと'],
    description: 'I\'m sure (that) ~. = 「きっと〜と思う」。',
  },
  thank: {
    matches: ['ありがとう'],
    description: 'Thank you for -ing ~. = 「〜してくれてありがとう」。',
  },
  thanks: {
    matches: ['おかげで'],
    description: 'thanks to ~ = 「〜のおかげで」。',
  },
  that: {
    matches: ['その', 'ので'],
    description: 'at that time = 「その時」。so ~ that .. = 「とても〜なので…」。',
  },
  there: {
    matches: ['向こう'],
    description: 'over there = 「向こうに」。',
  },
  these: {
    matches: ['最近'],
    description: 'these days = 「最近」。',
  },
  those: {
    matches: ['当時', 'あの頃'],
    description: 'in those days = 「当時、あの頃は」。',
  },
  volunteer: {
    matches: ['ボランティア'],
    description: 'work as a volunteer = 「ボランティア活動をする」。',
  },
  waiting: {
    matches: ['待って'],
    description: 'wait for ~ = 「〜を待つ」。',
  },
  washing: {
    matches: ['洗って'],
    description: 'washing = wash の -ing 形。Thank you for -ing ~. の -ing 部分。',
  },
  well: {
    matches: ['よくなる', '元気に'],
    description: 'get well = 「(健康状態が)よくなる」。',
  },
  why: {
    matches: ['なぜ', 'どう'],
    description: 'Why don\'t you ~? = 「〜してはどうですか」。',
  },
  works: {
    matches: ['活動する', '働く'],
    description: 'work as a volunteer = 「ボランティア活動をする」。',
  },
  world: {
    matches: ['世界'],
    description: 'all over the world = 「世界中で」。',
  },
  would: {
    matches: ['したい'],
    description: 'would like to ~ = 「〜したい(のですが)」。',
  },
  wrote: {
    matches: ['手紙を書いた'],
    description: 'wrote = write の過去形。write to ~ = 「〜に手紙を書く」。',
  },
}

